import type { OwnerReport } from "../../api/imports";

const cell = (v: string | number | null) => {
  const s = v === null ? "" : String(v);
  // A leading = + - @ would run as a formula in Excel; the message text is ours but the sheet name is the gym's.
  const safe = /^[=+\-@]/.test(s) ? `'${s}` : s;
  return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};
const toCsv = (rows: (string | number | null)[][]) => rows.map((r) => r.map(cell).join(",")).join("\r\n") + "\r\n";

/** Rows the import will skip, with why: the file to correct and re-upload. */
export function rejectedRowsCsv(r: OwnerReport): string {
  const why = new Map<string, string[]>();
  for (const i of r.issues) if (i.severity === "error") (why.get(`${i.file}|${i.row}`) ?? why.set(`${i.file}|${i.row}`, []).get(`${i.file}|${i.row}`)!).push(i.message);
  return toCsv([["File", "Row", "Kind", "What happens", "Codes", "Why"], ...r.skipped.rows.map((s) => [s.file, s.row, s.entity, s.disposition, s.codes.join(" "), (why.get(`${s.file}|${s.row}`) ?? []).join("; ")])]);
}

/** Every listed problem (errors and warnings) with its row number. */
export function issuesCsv(r: OwnerReport): string {
  return toCsv([["File", "Row", "Kind", "Severity", "Code", "Column", "Message"], ...r.issues.map((i) => [i.file, i.row, i.entity, i.severity, i.code, i.field, i.message])]);
}

export function downloadText(filename: string, text: string, type = "text/csv;charset=utf-8") {
  if (typeof URL.createObjectURL !== "function") return;
  const href = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10_000);
}
